import styled from "styled-components";

export const TitleStyled = styled.h1`
  flex: 1 0 0;
  margin-top: 32px;
  color: ${({ theme }) => theme?.colors?.text?.headings};
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 26px */

  span.brandColor3 {
    color: ${({ theme }) => theme?.colors?.theme?.brandColor3};
  }
`;
